import { TranslationStatus } from "../model/Translation";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export interface TranslationStats {
  totalItems: number;
  completedItems: number;
  pendingItems: number;
  translatedItems: number;
  initialLabelsToTranslate: number;
  needsReviewItems?: number;
  propertiesLabelCount: number;
  i15DLabelCount: number;
  helpTextLabelCount: number;
  translationStatus: TranslationStatus;
}

// Fetch the translation details
export const fetchTranslationDetails = async (translationId: number): Promise<TranslationStats> => {
  const response = await axiosInstance.get<{ data: TranslationStats }>(`/api/translation/${translationId}`);
  return response.data.data;
};
